export default __webpack_public_path__ + "static/media/012-drums.9ab9d5fb.svg";